<template>
    <div
        class="small-block"
        @change="sendDataForSaving(currentListOfGuests)"
    >
        <label for="" class="form-label">Guests</label>
        <div class="action-block">
            <div class="user-search-drop">
                <a class="dropdown-toggle" data-toggle="dropdown" href="#" id="dropdown-settings">
                    <div class="form-group form-group-1 ">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Select"
                        >
                    </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdown-settings">
                    <div class="text-scroll">
                        <div class="table-holder">
                            <table class="table">
                                <tbody>
                                <tr v-for="user in guestsWithCheckboxes"
                                    :key="user.id"
                                >
                                    <td class="color--text" style="width: 90%">
                                        <b>{{user.name ?? ''}} {{user.last_name ?? ''}}</b>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input-checkbox"
                                                    type="checkbox"
                                                    id="home-office"
                                                    v-model="user.isInvited"
                                                    @change="checkInviting(user)"
                                                >
                                                <label class="form-check-label" for="home-office"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h6 v-if="currentListOfGuests.length">Invited</h6>
        <div
            class="event-invited-block"
            style="padding: 0 14px 21px 19px;"
            v-if="currentListOfGuests.length"
        >
            <ul>
                <li
                    v-for="guest in currentListOfGuests"
                    :key="guest.id"
                >
                    <div class="user-info">
                        <div class="name">{{guest.name ?? ''}} {{guest.last_name ?? ''}}</div>
                        <button
                            class="img-btn"
                            @click="deleteInvitedPerson(guest)"
                        ><img src="/img/svg/del.svg" alt="delete">
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import EmitsHandler from "../../../../../resources/js/mixins/EmitsHandler";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import CalendarService from "./services/CalendarService";

export default {
    name: 'ListOfGuests',
    mixins: [EmitsHandler],
    emits: ['delete-users'],
    props: {
        invitedGuests: {
            type: Array
        }
    },
    data() {
        return {
            guestsWithCheckboxes:[],
            currentListOfGuests: [],
            listOfUsers: [],
            listOfDeletedUsers: [],
        }
    },
    methods: {
        deleteInvitedPerson(user) {
            const index = this.currentListOfGuests.findIndex(p => p.id === user.id);
            if (index !== -1) {
                this.currentListOfGuests.splice(index, 1);
                user.isInvited = false
                this.listOfDeletedUsers.push(user.id)
                this.$emit('delete-users', this.listOfDeletedUsers)
            }
        },
        checkInviting(user) {
            if (user.isInvited === true) {
                this.currentListOfGuests.push(user);
            } else {
                this.deleteInvitedPerson(user)
            }
        },
        async getListOfGuests() {
           try {
               const {data: response} = await CalendarService.getListOfUsersForCalendar()
               this.listOfUsers = response
               this.addCheckbox()
           } catch (e) {
               console.error(e)
           }
        },
        addCheckbox() {
            this.guestsWithCheckboxes = this.listOfUsers.map(user => {
                return {
                    id: user.id,
                    name: user.name,
                    email: user.email,
                    last_name: user.last_name,
                    isInvited: false,
                };
            });

            if (this.invitedGuests) {
                this.setCheckedUsers()
            }
        },
        setCheckedUsers() {
            this.guestsWithCheckboxes.forEach(user => {
                const foundUser = this.invitedGuests.find(guest => guest.id === user.id);
                if (foundUser) {
                    user.isInvited = true;
                }
            });
            this.currentListOfGuests = this.invitedGuests.map(guest => {
                return {
                    id: guest.app_user.id,
                    name: guest.app_user.name,
                    email: guest.app_user.email,
                    last_name: guest.app_user.last_name,
                    isInvited: true,
                }
            })
            this.sendDataForSaving(this.currentListOfGuests)
        },
    },
    mounted() {
        this.getListOfGuests()
    }
}

</script>


<style scoped>

</style>
